/* ===========================================================================
   I Like Company — theme behaviour
   Works on Liquid-rendered markup. Every block is guarded so the same file
   runs safely on the homepage and the product template.
   =========================================================================== */
(function () {
  'use strict';
  const $  = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.prototype.slice.call((r || document).querySelectorAll(s));

  /* ---- NAV: solid-on-scroll + mobile menu ------------------------------- */
  const nav = $('#nav');
  if (nav) {
    addEventListener('scroll', () => nav.classList.toggle('solid', scrollY > 40), { passive: true });
  }
  const burger = $('#hamburger');
  const mnav = $('#mnav');
  if (burger && mnav) {
    const FOCUSABLE = 'a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])';
    const focusables = () => $$(FOCUSABLE, mnav).filter((el) => el.offsetParent !== null);
    let lastFocused = null;

    const onKeydown = (e) => {
      if (e.key === 'Escape') { toggle(false); return; }
      if (e.key !== 'Tab') return;
      const items = focusables();
      if (!items.length) return;
      const first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    };

    const toggle = (open) => {
      const o = open !== undefined ? open : !mnav.classList.contains('open');
      mnav.classList.toggle('open', o);
      burger.classList.toggle('on', o);
      burger.setAttribute('aria-expanded', o);
      burger.setAttribute('aria-label', o ? 'Close menu' : 'Open menu');
      mnav.setAttribute('aria-hidden', o ? 'false' : 'true');
      document.body.style.overflow = o ? 'hidden' : '';
      if (o) {
        lastFocused = document.activeElement;
        const items = focusables();
        if (items.length) items[0].focus();
        document.addEventListener('keydown', onKeydown);
      } else {
        document.removeEventListener('keydown', onKeydown);
        (lastFocused || burger).focus();
      }
    };
    burger.addEventListener('click', () => toggle());
    $$('a', mnav).forEach((a) => a.addEventListener('click', () => toggle(false)));
  }

  /* ---- HERO: cycle the "I like ___." word ------------------------------- */
  const heroW = $('#heroW');
  const heroChips = $('#chips');
  if (heroW && heroChips) {
    const words = $$('.chip', heroChips).map((c) => c.dataset.word);
    let hi = 0, cycling = true;
    const sync = () => $$('.chip', heroChips).forEach((c, n) => c.classList.toggle('on', n === hi));
    const show = (n) => {
      hi = (n + words.length) % words.length;
      heroW.style.opacity = '0';
      setTimeout(() => { heroW.textContent = words[hi]; heroW.style.opacity = '1'; sync(); }, 280);
    };
    if (words.length) {
      heroW.textContent = words[0]; sync();
      setInterval(() => { if (cycling) show(hi + 1); }, 2300);
      heroChips.addEventListener('click', (e) => {
        const b = e.target.closest('.chip'); if (!b) return;
        cycling = false; show($$('.chip', heroChips).indexOf(b));
        clearTimeout(window._hr); window._hr = setTimeout(() => (cycling = true), 9000);
      });
    }
  }

  /* ---- CAP CAROUSEL ----------------------------------------------------- */
  const track = $('#track');
  const view = $('.carview');
  if (track && view) {
    const slides = $$('.slide', track);
    const dotsEl = $('#dots');
    const chipsEl = $('#spinChips');
    let i = 0, curX = 0;

    if (dotsEl) dotsEl.innerHTML = slides.map((_, n) =>
      `<button data-i="${n}" aria-label="Slide ${n + 1}"></button>`).join('');

    const fitWords = () => {
      const W = view.clientWidth;
      $$('.word', track).forEach((w) => {
        let fs = W * 0.073; w.style.fontSize = fs + 'px';
        const max = W * 0.42; let g = 0;
        while (w.scrollWidth > max && fs > 9 && g++ < 60) { fs -= 1; w.style.fontSize = fs + 'px'; }
      });
    };
    const go = (n) => {
      i = (n + slides.length) % slides.length;
      const target = -i * 100, start = curX, t0 = performance.now(), dur = 520;
      (function fr(now) {
        const q = Math.min(1, (now - t0) / dur), e = 1 - Math.pow(1 - q, 3);
        curX = start + (target - start) * e;
        track.style.transform = `translateX(${curX}%)`;
        if (q < 1) requestAnimationFrame(fr);
      })(performance.now());
      if (dotsEl) $$('button', dotsEl).forEach((b) => b.classList.toggle('on', +b.dataset.i === i));
      if (chipsEl) $$('.chip', chipsEl).forEach((b) => b.classList.toggle('on', +b.dataset.i === i));
    };
    fitWords(); go(0);
    addEventListener('resize', fitWords);

    const prev = $('#carPrev'), next = $('#carNext');
    if (prev) prev.addEventListener('click', () => go(i - 1));
    if (next) next.addEventListener('click', () => go(i + 1));
    if (dotsEl) dotsEl.addEventListener('click', (e) => { const b = e.target.closest('button'); if (b) go(+b.dataset.i); });
    if (chipsEl) chipsEl.addEventListener('click', (e) => { const b = e.target.closest('.chip'); if (b) go(+b.dataset.i); });

    let x0 = null;
    view.addEventListener('pointerdown', (e) => (x0 = e.clientX));
    addEventListener('pointerup', (e) => {
      if (x0 == null) return; const dx = e.clientX - x0;
      if (Math.abs(dx) > 44) go(i + (dx < 0 ? 1 : -1)); x0 = null;
    });
  }

  /* ---- CUSTOMIZER: live cap preview ------------------------------------- */
  const custWord = $('#custWord'), capWord = $('#capWord');
  if (custWord && capWord) {
    const sizeInput = () => (custWord.style.width = Math.max(2, custWord.value.length + 1) + 'ch');
    custWord.addEventListener('input', () => { capWord.textContent = custWord.value || '___'; sizeInput(); });
    sizeInput();
    const suggest = $('#suggest');
    if (suggest) suggest.addEventListener('click', (e) => {
      const b = e.target.closest('button'); if (!b) return;
      custWord.value = b.dataset.w; capWord.textContent = b.dataset.w; sizeInput();
    });
    const capSw = $('#capSw');
    if (capSw) capSw.addEventListener('click', (e) => {
      const b = e.target.closest('button'); if (!b) return;
      $$('button', capSw).forEach((x) => x.classList.remove('on')); b.classList.add('on');
      const cap = $('.cap');
      cap.style.setProperty('--cap-col', b.dataset.c);
      cap.style.setProperty('--cap-txt', b.dataset.t);
    });
  }

  /* ---- PRODUCT: gallery, swatches, qty, accordion, add-to-bag ----------- */
  const pdp = $('.pdp');
  if (pdp) {
    const galMain = $('#galMain'), galThumbs = $('#galThumbs');
    if (galThumbs) galThumbs.addEventListener('click', (e) => {
      const b = e.target.closest('button'); if (!b) return;
      const cover = b.querySelector('img').classList.contains('cover');
      galMain.style.opacity = '0';
      setTimeout(() => {
        galMain.src = b.dataset.src; galMain.className = cover ? 'cover' : ''; galMain.style.opacity = '1';
      }, 150);
      $$('button', galThumbs).forEach((x) => x.classList.toggle('on', x === b));
    });

    let qty = 1;
    const qEl = $('#qty');
    const minus = $('#minus'), plus = $('#plus');
    if (minus) minus.addEventListener('click', () => { qty = Math.max(1, qty - 1); qEl.textContent = qty; });
    if (plus) plus.addEventListener('click', () => { qty = Math.min(9, qty + 1); qEl.textContent = qty; });

    $$('.acc-item').forEach((it) => {
      const q = $('.acc-q', it), a = $('.acc-a', it);
      if (it.classList.contains('open')) a.style.maxHeight = a.scrollHeight + 'px';
      q.addEventListener('click', () => {
        const open = it.classList.contains('open');
        $$('.acc-item').forEach((o) => { o.classList.remove('open'); $('.acc-a', o).style.maxHeight = '0'; });
        if (!open) { it.classList.add('open'); a.style.maxHeight = a.scrollHeight + 'px'; }
      });
    });

    /* Add to bag → Shopify AJAX Cart API. Falls back to a toast if unavailable. */
    const addBtn = $('#addbag'), toast = $('#toast'), cartEl = $('#cart');
    if (addBtn) addBtn.addEventListener('click', function () {
      const variantId = addBtn.dataset.variantId;
      const done = (count) => {
        if (cartEl && count != null) cartEl.textContent = 'Cart (' + count + ')';
        if (toast) { toast.textContent = qty + ' × ' + (addBtn.dataset.title || 'item') + ' added'; toast.classList.add('show'); }
        addBtn.classList.add('added');
        clearTimeout(window._t); window._t = setTimeout(() => { if (toast) toast.classList.remove('show'); addBtn.classList.remove('added'); }, 1900);
      };
      if (variantId && window.fetch) {
        fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: qty })
        }).then(() => fetch('/cart.js')).then((r) => r.json()).then((c) => done(c.item_count)).catch(() => done(null));
      } else { done(null); }
    });
  }
})();

/* ---- CART DRAWER -------------------------------------------------------- */
(function () {
  'use strict';
  var drawer = document.getElementById('cdrawer');
  var ov = document.getElementById('cdrawerOv');
  if (!drawer || !ov) return;

  var itemsEl = document.getElementById('cdItems');
  var footEl = document.getElementById('cdFoot');
  var subEl = document.getElementById('cdSubtotal');
  var countEl = document.getElementById('cdCount');
  var cartLink = document.getElementById('cart');

  var fmt = function (cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  };

  function render(cart) {
    if (cartLink) cartLink.textContent = 'Cart (' + cart.item_count + ')';
    if (countEl) countEl.textContent = '(' + cart.item_count + ')';
    if (!cart.items.length) {
      itemsEl.innerHTML = '<p class="cdrawer-empty mono muted">Your bag is empty.</p>';
      footEl.hidden = true;
      return;
    }
    footEl.hidden = false;
    subEl.textContent = fmt(cart.items_subtotal_price);
    itemsEl.innerHTML = cart.items.map(function (it) {
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/, '_200x$1$2') : '';
      return '<div class="cd-item" data-key="' + it.key + '">' +
        '<div class="im">' + (img ? '<img src="' + img + '" alt="">' : '') + '</div>' +
        '<div>' +
          '<div class="ti">' + it.product_title + '</div>' +
          (it.variant_title && it.variant_title !== 'Default Title' ? '<div class="va">' + it.variant_title + '</div>' : '') +
          '<div class="qt">' +
            '<button data-dec aria-label="decrease">&minus;</button>' +
            '<span class="q">' + it.quantity + '</span>' +
            '<button data-inc aria-label="increase">+</button>' +
          '</div>' +
        '</div>' +
        '<div>' +
          '<div class="pr">' + fmt(it.final_line_price) + '</div>' +
          '<button class="rm" data-rm>Remove</button>' +
        '</div>' +
      '</div>';
    }).join('');
  }

  function refresh() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(render);
  }

  function change(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(render);
  }

  function open() {
    refresh().then(function () {
      ov.hidden = false;
      requestAnimationFrame(function () {
        ov.classList.add('open');
        drawer.classList.add('open');
      });
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    });
  }

  function close() {
    ov.classList.remove('open');
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(function () { ov.hidden = true; }, 320);
  }

  if (cartLink) cartLink.addEventListener('click', function (e) { e.preventDefault(); open(); });
  ov.addEventListener('click', close);
  var x = document.getElementById('cdrawerX');
  if (x) x.addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('open')) close(); });

  itemsEl.addEventListener('click', function (e) {
    var row = e.target.closest('.cd-item');
    if (!row) return;
    var key = row.dataset.key;
    var q = parseInt(row.querySelector('.q').textContent, 10);
    if (e.target.closest('[data-inc]')) change(key, q + 1);
    else if (e.target.closest('[data-dec]')) change(key, Math.max(0, q - 1));
    else if (e.target.closest('[data-rm]')) change(key, 0);
  });

  /* open the drawer after add-to-bag */
  var addBtn = document.getElementById('addbag');
  if (addBtn) addBtn.addEventListener('click', function () {
    setTimeout(open, 650);
  });
})();

/* ---- CINEMATIC SCROLL: staggered reveals + parallax ---------------------- */
(function () {
  'use strict';
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* Reveal-on-scroll with per-sibling stagger */
  var SELECTORS = [
    '.pcard', '.cat', '.idx-row', '.sec-head', '.spec .col',
    '.look-grid figure', '.mani .big', '.mani p', '.also .lead', '.also .cloud',
    '.band .big', '.band p', '.coll-subnav-title'
  ];
  var els = document.querySelectorAll(SELECTORS.join(','));
  var groups = new Map();
  els.forEach(function (el) {
    var parent = el.parentElement;
    if (!groups.has(parent)) groups.set(parent, 0);
    var n = groups.get(parent);
    el.classList.add('rvl');
    el.style.setProperty('--rvl-d', Math.min(n * 0.08, 0.5) + 's');
    groups.set(parent, n + 1);
  });
  /* Ads-bounce fix 2026-07-29: never blank the first paint. Anything already
     inside the initial viewport reveals immediately (stagger kept via --rvl-d);
     a late safety reveals whatever the observer missed (in-app browsers). */
  var vh0 = innerHeight;
  els.forEach(function (el) {
    if (el.getBoundingClientRect().top < vh0 * 1.05) el.classList.add('in');
  });
  setTimeout(function () {
    els.forEach(function (el) { el.classList.add('in'); });
  }, 2500);
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  } else {
    els.forEach(function (el) { el.classList.add('in'); });
  }

  /* Parallax: hero video drifts + lifestyle band images counter-scroll */
  var heroMedia = document.querySelector('.hero video, .hero .ph-vid');
  var bandImgs = Array.prototype.slice.call(document.querySelectorAll('.band img, .band video'));
  if (!heroMedia && !bandImgs.length) return;
  if (heroMedia) heroMedia.classList.add('plx');
  bandImgs.forEach(function (im) { im.classList.add('plx'); im.style.height = '140%'; im.style.top = '-20%'; });

  var ticking = false;
  function frame() {
    ticking = false;
    var vh = innerHeight;
    if (heroMedia) {
      var y = Math.min(scrollY, vh);
      heroMedia.style.transform = 'translateY(' + (y * 0.45) + 'px) scale(' + (1 + y / vh * 0.14) + ')';
    }
    bandImgs.forEach(function (im) {
      var r = im.parentElement.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return;
      var p = (r.top + r.height / 2 - vh / 2) / vh; /* -0.5..0.5 through viewport */
      im.style.transform = 'translateY(' + (p * r.height * 0.3) + 'px)';
    });
  }
  addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(frame); }
  }, { passive: true });
  frame();
})();

/* ---- SIGN-UP POPUP (sticker pack) -------------------------------------- */
(function () {
  'use strict';
  var pop = document.getElementById('ilcPop');
  var ov = document.getElementById('ilcPopOv');
  if (!pop || !ov) return;

  var SEEN = 'ilc_pop_seen_v1';
  var posted = pop.querySelector('[data-state="done"]') !== null;

  function open() {
    ov.hidden = false; pop.hidden = false;
    requestAnimationFrame(function () { ov.classList.add('open'); pop.classList.add('open'); });
    pop.setAttribute('aria-hidden', 'false');
  }
  function close() {
    ov.classList.remove('open'); pop.classList.remove('open');
    pop.setAttribute('aria-hidden', 'true');
    try { localStorage.setItem(SEEN, '1'); } catch (e) {}
    setTimeout(function () { ov.hidden = true; pop.hidden = true; }, 350);
  }

  var x = document.getElementById('ilcPopX');
  var decline = document.getElementById('ilcPopDecline');
  var done = document.getElementById('ilcPopDone');
  if (x) x.addEventListener('click', close);
  if (decline) decline.addEventListener('click', close);
  if (done) done.addEventListener('click', close);
  ov.addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && pop.classList.contains('open')) close(); });

  /* map interest checkboxes → hidden tags + note so they save to the customer */
  var likes = document.getElementById('ilcLikes');
  var tagsInput = document.getElementById('ilcTags');
  var noteInput = document.getElementById('ilcNote');
  var form = document.getElementById('ilcPopForm');
  if (form && likes && tagsInput) {
    form.addEventListener('submit', function () {
      var chosen = [].slice.call(likes.querySelectorAll('input:checked')).map(function (c) { return c.value; });
      tagsInput.value = ['community-signup'].concat(chosen).join(', ');
    });
  }

  /* If the form just posted successfully, show the thank-you immediately. */
  if (posted) { open(); return; }

  /* Otherwise show once per visitor. Ads-bounce fix 2026-07-29: first
     pageview of a session (cold ad landings) waits 30s; from the second
     pageview — a browsing visitor — keep the quick 6s. */
  var seen;
  try { seen = localStorage.getItem(SEEN); } catch (e) { seen = null; }
  var pv = 1;
  try {
    pv = (parseInt(sessionStorage.getItem('ilc_pv'), 10) || 0) + 1;
    sessionStorage.setItem('ilc_pv', String(pv));
  } catch (e) {}
  if (!seen) { setTimeout(open, pv >= 2 ? 6000 : 30000); }
})();

/* ---- PICK YOUR LIKE carousel — pop the centred tile ---------------------- */
(function () {
  'use strict';
  var car = document.getElementById('catCarousel');
  if (!car) return;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var items = [].slice.call(car.querySelectorAll('.cat'));
  if (!items.length) return;
  var raf = null;
  function update() {
    raf = null;
    var box = car.getBoundingClientRect();
    var center = box.left + box.width / 2;
    var best = null, bestDist = Infinity;
    items.forEach(function (it) {
      var r = it.getBoundingClientRect();
      var d = Math.abs((r.left + r.width / 2) - center);
      if (d < bestDist) { bestDist = d; best = it; }
    });
    items.forEach(function (it) { it.classList.toggle('is-center', it === best); });
  }
  function onScroll() { if (!raf) raf = requestAnimationFrame(update); }
  car.addEventListener('scroll', onScroll, { passive: true });
  addEventListener('resize', onScroll, { passive: true });
  /* nudge the scroll so the first "pop" isn't stuck on the left edge */
  requestAnimationFrame(function () { update(); });
})();

/* ---- PICK YOUR LIKE — multi-tile cap carousel --------------------------- */
(function () {
  'use strict';
  var scroll = document.getElementById('capScroll');
  if (!scroll) return;
  var tiles = [].slice.call(scroll.querySelectorAll('.captile'));
  if (!tiles.length) return;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var raf = null;
  function centerTile() {
    raf = null;
    var box = scroll.getBoundingClientRect();
    var c = box.left + box.width / 2, best = null, bd = Infinity;
    tiles.forEach(function (t) {
      var r = t.getBoundingClientRect();
      var d = Math.abs((r.left + r.width / 2) - c);
      if (d < bd) { bd = d; best = t; }
    });
    tiles.forEach(function (t) { t.classList.toggle('is-center', t === best); });
    return best;
  }
  function onScroll() { if (!raf) raf = requestAnimationFrame(centerTile); }
  scroll.addEventListener('scroll', onScroll, { passive: true });
  addEventListener('resize', onScroll, { passive: true });
  function scrollToTile(t) {
    var box = scroll.getBoundingClientRect(), r = t.getBoundingClientRect();
    scroll.scrollBy({ left: (r.left + r.width / 2) - (box.left + box.width / 2), behavior: reduce ? 'auto' : 'smooth' });
  }
  function step(dir) {
    var cur = centerTile(); if (!cur) return;
    var i = Math.max(0, Math.min(tiles.length - 1, tiles.indexOf(cur) + dir));
    scrollToTile(tiles[i]);
  }
  var prev = document.getElementById('carPrev'), next = document.getElementById('carNext');
  if (prev) prev.addEventListener('click', function () { step(-1); });
  if (next) next.addEventListener('click', function () { step(1); });
  var chips = document.getElementById('spinChips');
  if (chips) chips.addEventListener('click', function (e) {
    var b = e.target.closest('.chip'); if (!b) return;
    var i = +b.dataset.i;
    if (tiles[i]) { scrollToTile(tiles[i]); [].forEach.call(chips.querySelectorAll('.chip'), function (c) { c.classList.toggle('on', c === b); }); }
  });
  requestAnimationFrame(centerTile);
})();


/* ---- FEATURED PRODUCTS — scroll progress bar --------------------------- */
(function () {
  'use strict';
  var sc = document.getElementById('prodScroll');
  var bar = document.getElementById('prodProgBar');
  var wrap = bar && bar.parentElement;
  if (!sc || !bar || !wrap) return;
  var raf = null;
  function update() {
    raf = null;
    var max = sc.scrollWidth - sc.clientWidth;
    if (max <= 2) { wrap.style.display = 'none'; return; }
    wrap.style.display = '';
    var frac = sc.clientWidth / sc.scrollWidth;          // how much is in view
    var barW = Math.max(0.14, frac);                     // bar as % of track
    bar.style.width = (barW * 100) + '%';
    var prog = sc.scrollLeft / max;                       // 0..1
    var travel = wrap.clientWidth * (1 - barW);
    bar.style.transform = 'translateX(' + (prog * travel) + 'px)';
  }
  function onScroll() { if (!raf) raf = requestAnimationFrame(update); }
  sc.addEventListener('scroll', onScroll, { passive: true });
  addEventListener('resize', onScroll, { passive: true });
  requestAnimationFrame(update);
})();


/* ---- FEATURED PRODUCTS — arrows + centre-focus ------------------------- */
(function () {
  'use strict';
  var sc = document.getElementById('prodScroll');
  if (!sc) return;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cards = function () { return [].slice.call(sc.querySelectorAll('.pcard')); };
  var raf = null;
  function focusCentre() {
    raf = null;
    var box = sc.getBoundingClientRect(), c = box.left + box.width / 2, best = null, bd = Infinity;
    cards().forEach(function (card) {
      var r = card.getBoundingClientRect();
      var d = Math.abs((r.left + r.width / 2) - c);
      if (d < bd) { bd = d; best = card; }
    });
    cards().forEach(function (card) { card.classList.toggle('is-focus', card === best); });
  }
  function onScroll() { if (!raf) raf = requestAnimationFrame(focusCentre); }
  sc.addEventListener('scroll', onScroll, { passive: true });
  addEventListener('resize', onScroll, { passive: true });
  function step(dir) {
    var first = sc.querySelector('.pcard');
    var w = first ? first.getBoundingClientRect().width + 18 : sc.clientWidth * 0.8;
    sc.scrollBy({ left: dir * w, behavior: reduce ? 'auto' : 'smooth' });
  }
  var prev = document.getElementById('prodPrev'), next = document.getElementById('prodNext');
  if (prev) prev.addEventListener('click', function () { step(-1); });
  if (next) next.addEventListener('click', function () { step(1); });
  focusCentre();
  if (!reduce) { setTimeout(function () { sc.classList.add('focus-on'); focusCentre(); }, 900); }
})();


/* ---- HERO — multi-video crossfade rotation ----------------------------- */
(function () {
  'use strict';
  var media = document.getElementById('heroMedia');
  if (!media) return;
  var vids = [].slice.call(media.querySelectorAll('.hero-vid'));
  if (!vids.length) return;
  var play = function (v) { var p = v.play && v.play(); if (p && p.catch) p.catch(function () {}); };
  if (vids.length === 1) { vids[0].loop = true; play(vids[0]); return; }
  vids.forEach(function (v) { v.loop = false; });
  function show(n) {
    vids.forEach(function (v, i) { v.classList.toggle('on', i === n); });
    var v = vids[n]; try { v.currentTime = 0; } catch (e) {} play(v);
  }
  vids.forEach(function (v, i) {
    v.addEventListener('ended', function () { show((i + 1) % vids.length); });
  });
  show(0);
})();


/* ---- CINEMATIC SCROLL — hero handoff + lookbook parallax ---------------- */
(function () {
  'use strict';
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var heroInner = document.querySelector('.hero-inner');
  var lookImgs = [].slice.call(document.querySelectorAll('.look-grid figure img'));
  if (!heroInner && !lookImgs.length) return;
  lookImgs.forEach(function (im) {
    im.style.position = 'absolute';
    im.style.top = '-9%'; im.style.left = '0';
    im.style.width = '100%'; im.style.height = '118%';
    im.style.willChange = 'transform';
  });
  var ticking = false;
  function frame() {
    ticking = false;
    var vh = innerHeight;
    if (heroInner) {
      var p = Math.min(1, Math.max(0, scrollY / (vh * 0.9)));
      heroInner.style.transform = 'translateY(' + (p * -64) + 'px)';
      heroInner.style.opacity = String(1 - p * 0.92);
    }
    lookImgs.forEach(function (im) {
      var r = im.parentElement.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return;
      var q = (r.top + r.height / 2 - vh / 2) / vh;   /* -0.5..0.5 through viewport */
      im.style.transform = 'translateY(' + (q * r.height * 0.14) + 'px)';
    });
  }
  addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(frame); }
  }, { passive: true });
  addEventListener('resize', frame, { passive: true });
  frame();
})();


/* ---- PRODUCT — collapse "The details" and "Care" in the description -------- */
(function () {
  'use strict';
  var desc = document.querySelector('.pdp .pdp-desc');
  if (!desc) return;
  var heads = [].filter.call(desc.querySelectorAll('p'), function (p) {
    var s = p.querySelector('strong');
    if (!s) return false;
    var t = s.textContent.trim().toLowerCase();
    return t === 'the details' || t === 'care';
  });
  heads.forEach(function (p) {
    var ul = p.nextElementSibling;
    if (!ul || ul.tagName !== 'UL') return;
    var det = document.createElement('details');
    det.className = 'pdp-collapse';
    var sum = document.createElement('summary');
    sum.textContent = p.querySelector('strong').textContent.trim();
    det.appendChild(sum);
    det.appendChild(ul);            /* moves the <ul> inside */
    p.parentNode.insertBefore(det, p);
    p.parentNode.removeChild(p);
  });
})();


/* ---- SHIPPING POPUP (product + collection) --------------------------------- */
(function () {
  'use strict';
  var pop = document.getElementById('shipPop');
  if (!pop) return;
  var SEEN = 'ilc_ship_pop_seen_v1';
  function close() {
    pop.classList.remove('open');
    try { localStorage.setItem(SEEN, '1'); } catch (e) {}
    setTimeout(function () { pop.hidden = true; }, 400);
  }
  var x = document.getElementById('shipPopX');
  if (x) x.addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && pop.classList.contains('open')) close(); });
  var seen;
  try { seen = localStorage.getItem(SEEN); } catch (e) { seen = null; }
  if (seen) return;
  setTimeout(function () {
    pop.hidden = false;
    /* Ads-bounce fix 2026-07-29: mark seen at SHOW time, so navigating away
       before it auto-closes doesn't re-trigger it on every page. */
    try { localStorage.setItem(SEEN, '1'); } catch (e) {}
    requestAnimationFrame(function () { pop.classList.add('open'); });
    setTimeout(function () { if (pop.classList.contains('open')) close(); }, 9000);
  }, 2500);
})();